import React, { useCallback, useEffect, useReducer, useState } from "react"
import type { FiltroClientes } from "../../../services/clientesFornecedor"
import { obterClientesPainel } from "../../../services/clientesFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ClientesFornecedorInicial, TAMANHO_PAGINA } from "../models/clientesFornecedorModel"
import { ClientesFornecedorActionsTypes } from "./clientesFornecedorActions"
import { ClientesFornecedorContext } from "./ClientesFornecedorContext"
import { clientesFornecedorReducer } from "./clientesFornecedorReducer"

export function ClientesFornecedorContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(clientesFornecedorReducer, ClientesFornecedorInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const buscar = useCallback(
        async (filtro: FiltroClientes, pagina: number) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            try {
                setLoading(true)
                const response = await obterClientesPainel(
                    autorizacao,
                    filtro,
                    pagina,
                    TAMANHO_PAGINA
                )
                if ("retornoErro" in response) {
                    setErroCarregamento(response.mensagem || "Erro ao carregar clientes")
                } else {
                    setErroCarregamento(null)
                    dispatch({
                        type: ClientesFornecedorActionsTypes.CARREGAR_RESULTADO,
                        payload: { clientes: response.clientes, total: response.total },
                    })
                    dispatch({
                        type: ClientesFornecedorActionsTypes.MUDAR_PAGINA,
                        payload: { pagina },
                    })
                }
            } catch {
                setErroCarregamento("Erro ao carregar clientes")
            } finally {
                setLoading(false)
            }
        },
        [setLoading]
    )

    useEffect(() => {
        buscar(ClientesFornecedorInicial.filtro, 0)
    }, [])

    return (
        <ClientesFornecedorContext.Provider value={{ dados, dispatch, erroCarregamento, buscar }}>
            <Loading />
            {children}
        </ClientesFornecedorContext.Provider>
    )
}
